import defaultReducer from "./defaultReducer";

export default defaultReducer("FLOAT_LEVEL_SETTINGS_MODAL", {
  open: false,
  maximumFloats: [],
  lowFloats: [],
});
